import PricingContainer from "./containers/PricingContainer";
import "./styles.scss";

export default PricingContainer;
